import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Enum } from '../../../utility/enum.enum';
import { AppMessage } from './../../../Common/appMessage';
import { AppGlobals } from './../../../Common/Services/app.global';
import { SharedService } from './../../../Common/Services/shared.service';
import { Utility } from './../../../Common/Services/utility';
import { AppConfig } from 'app/Common/appConfiguration';
import { userRole_regionalAdmin } from './../../../Common/appConstant';

@Component({
  selector: 'app-adm-update-regional-admin',
  templateUrl: './adm-update-regional-admin.component.html',
  styleUrls: ['./adm-update-regional-admin.component.css']
})
export class AdmUpdateRegionalAdminComponent implements OnInit {

  form: FormGroup;
  regionFilteredOptions: any;
  countryFilteredOptions: any;
  id: number;
  approverOptions: any;
  pageConfig: {
    title: string,
    isSaveDisable: boolean,
    isEditDisable: boolean,
    isRetireDisable: boolean
  };
  countryOptions: any;
  constructor(private _sharedService: SharedService, public _utility: Utility, private _activatedRoute: ActivatedRoute
    , private _appMessage: AppMessage, public _appGlobal: AppGlobals) {
    this.form = new FormGroup(
      {
        firstName: new FormControl(''),
        lastName: new FormControl(''),
        email: new FormControl('', [Validators.pattern(AppConfig.emailPattern)]),
        contactNo: new FormControl('', [Validators.pattern(AppConfig.phoneNumberRegEx), Validators.required]),
        rhId: new FormControl('', Validators.required),
        regionId: new FormControl('', Validators.required),
        isApprover: new FormControl('', Validators.required),
        approverCountryId: new FormControl('', Validators.required)
      }
    )
    this.pageConfig = {
      title: 'Regional Administrator',
      isSaveDisable: false,
      isEditDisable: true,
      isRetireDisable: true
    }
    this.approverOptions = [
      'Yes', 'No'
    ];

    this.form.valueChanges
      .debounceTime(400)
      .subscribe(form => {
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true); // display confirm box for FORM changes
        }
      });
  }

  ngOnInit() {
    this._appGlobal.routeWithID = false;
    this._utility.clearTxnStatus(); // close confirm box for FORM changes

    if (this._sharedService.regionList) {
      this._utility.setDataInComboField('region', null, this.form.controls.regionId, this);
    } else {
      this._sharedService.getComboFieldsData(Enum.Region, (response) => {
        this._sharedService.regionList = response.response;
        this._utility.setDataInComboField('region', null, this.form.controls.regionId, this);
      });
    }

    if (this._sharedService.countryList) {
      this.countryOptions = this._sharedService.countryList;
    } else {
      this._sharedService.getComboFieldsData(Enum.Country, (response) => {
        this._sharedService.countryList = response.response;
        this.countryOptions = this._sharedService.countryList;
      });
    }

    this.setDataOnForm();

    this.form.controls.isApprover
      .valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe((value) => {
        if (!this.form.disabled) {
          if (value.toLowerCase() == 'yes') {
            this.form.controls.approverCountryId.enable();
          } else {
            this.form.controls.approverCountryId.disable();
            this.form.controls.approverCountryId.setValue([]); // If you set isApprover as No , remove all selected approver countries
          }
        }
      });
  }

  setDataOnForm() {
    this.id = this._activatedRoute.snapshot.params['id']; // regional admin Primary Id
    if (this.id == 0) {
      this.pageConfig.title = 'Add ' + this.pageConfig.title;
    } else {
      this.getData();
      this.pageConfig.title = 'Edit ' + this.pageConfig.title;
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = false;
      this._utility.disableEnableForm(this.form, true);
    }
  }

  getData() {
    let params = "?userRole="+userRole_regionalAdmin+"&userId=" + this.id;
    this._sharedService.getUsers(params).subscribe((response: any) => {
      this._utility.onSuccessCallback(response, null, () => {
        let data = response.response.results[0];
        data.isApprover = data.isApprover ? 'Yes' : 'No';
        this.form.patchValue(this._utility.manageFormComboData(data));
        if (data.status == Enum.StatusRetire) {
          this.pageConfig.isRetireDisable = true;
          this.pageConfig.isEditDisable = true;
          this.pageConfig.isSaveDisable = true;
        } else {
          this.pageConfig.isRetireDisable = false;
          this.pageConfig.isEditDisable = false;
          this.pageConfig.isSaveDisable = true;
        }
      });
    }, error => this._utility.onErrorCallback(error));
  }

  onSave() {
    let formValues = this.form.getRawValue();
    formValues = this._utility.manageFormDataforSave(formValues);
    formValues.isApprover = formValues.isApprover.toLowerCase() == 'yes' ? true : false;
    formValues.id = this.id;
    this._utility.addLoaderCount();
    formValues.approverCountryId = formValues.approverCountryId == "" ? [] : formValues.approverCountryId;
    this._sharedService.saveAdminDetail(formValues, Enum.RoleTypeRegionalAdmin)
      .subscribe(
      response => {
        let msg = this.id == 0 ? this._appMessage.getItem['UMsg00030'] : this._appMessage.getItem['UMsg00031'];
        this._utility.onSuccessCallback(response, msg, () => {
          this.pageConfig.isSaveDisable = true;
          this.pageConfig.isEditDisable = false;
          if (this.id == 0) {
            this.pageConfig.isRetireDisable = false; // disable retire button after save new record
          }
          this.id = response.response.id; // set new user Id
          this._utility.disableEnableForm(this.form, true);
          this._utility.clearTxnStatus(); // close confirm box for FORM changes
        });
      }, error => this._utility.onErrorCallback(error));
  }

  onEdit() {
    this.pageConfig.isSaveDisable = false;
    this.pageConfig.isEditDisable = true;
    this._utility.disableEnableForm(this.form, false);
    if (this.form.controls.isApprover.value.toLowerCase() == 'yes') {
      this.form.controls.approverCountryId.enable();
    } else {
      this.form.controls.approverCountryId.disable();
    }
  }

  onChangeStatus(status : boolean) {
    this._utility.doRetireActiveAdmin(this.id, Enum.RoleTypeRegionalAdmin, status, () => {
      this.pageConfig.isSaveDisable = true;
      this.pageConfig.isEditDisable = !status;
      this.pageConfig.isRetireDisable = !status;
      this._utility.disableEnableForm(this.form, true);
    });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-regional-admin/adm-update-regional-admin/adm-update-regional-admin.component.ts